import { useEffect, useRef, useState } from 'react';

type UseLazyLoadOptions = {
  onIntersect: () => void;
  once?: boolean;
};

export function useLazeApi({ onIntersect, once = true }: UseLazyLoadOptions) {
  const elementRef = useRef<any>(null);
  const observer = useRef<IntersectionObserver | null>(null);
  const [hasTriggered, setHasTriggered] = useState(false);

  useEffect(() => {
    if (!elementRef.current || (once && hasTriggered)) return;

    observer.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          onIntersect();
          if (once) {
            observer.current?.disconnect();
            setHasTriggered(true);
          }
        }
      });
    }, {
      root: null,
      threshold: 0.1 
    });

    observer.current.observe(elementRef.current);

    return () => {
      observer.current?.disconnect();
    };
  }, [onIntersect, once, hasTriggered]);

  return elementRef;
}
